export default [
  [0.195, 0.225, 0.275, 0.325, 0.375, 0.4, 0.45],
  [0.26, 0.275, 0.325, 0.4, 0.45, 0.55, 0.65],
  [0.325, 0.375, 0.425, 0.575, 0.625, 0.725, 0.85],
  [0.8, 0.9, 1.075, 1.125, 1.35, 1.5, 1.6],
  [1.4, 1.5, 1.7, 1.9, 2.0, 2.3, 2.5],
  [0.5, 0.6, 0.9, 1.3, 1.85, 2.0, 2.1],
  [0.45, 0.5, 0.6, 0.65, 0.7, 0.8, 0.9],
] as const;
